import { render } from "./ScrollTop.vue?vue&type=template&id=7e98fcf3&ts=true"
import script from "./ScrollTop.vue?vue&type=script&lang=ts"
export * from "./ScrollTop.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\kevintam\\Documents\\pokeraudit\\pokeraudit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__